import { getResponsibleName } from "../../../../../functions/getNames";

const MeetingHeader = ({ empresa, admins, accountants }) => (
	<div className="w-full flex flex-row justify-between">
		<p className="text-sm font-bold text-gray-500">{empresa.name}</p>
		<p className="text-sm font-bold text-gray-500">
			{getResponsibleName(empresa, accountants, admins)}
		</p>
	</div>
);

export default MeetingHeader;
